import React from 'react';
import { bool, string, func } from 'prop-types';
import { Modal, Button, Skeleton, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const ImageModal = ({
  title,
  imageSrc,
  visible,
  handleCloseModal,
  loading,
  submitting,
  hideCloseFooter,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className="image-modal"
      title={title}
      visible={visible}
      onCancel={handleCloseModal}
      centered
      footer={
        hideCloseFooter
          ? null
          : [
              <Button type="primary" onClick={handleCloseModal}>
                {t('cards:FormContent.modalButton')}
              </Button>,
            ]
      }
    >
      {loading ? (
        <Skeleton />
      ) : (
        <Spin spinning={submitting}>
          <img src={imageSrc} alt={title} />
        </Spin>
      )}
    </Modal>
  );
};

ImageModal.propTypes = {
  title: string.isRequired,
  imageSrc: string.isRequired,
  visible: bool.isRequired,
  handleCloseModal: func.isRequired,
  loading: bool,
  submitting: bool,
  hideCloseFooter: bool,
};

ImageModal.defaultProps = {
  loading: false,
  submitting: false,
  hideCloseFooter: false,
};

export default ImageModal;
